import { useEffect } from 'react';

/**
 * `/for-shops` redirects to the marketing site's page of the same name.
 *
 * This used to be a second, hand-maintained pitch page living inside the app,
 * and it drifted badly: the real one at bit-brew.coffee/for-shops carries six
 * benefits to this one's three, four onboarding steps to its three, and copy
 * that mentions wallet cards, in-app advertising and live stats — none of which
 * the in-app copy had ever heard of. It also kept the pre-coral skin months
 * after the redesign, so a shop owner tapping LEARN MORE mid-signup was shown
 * an older, thinner product than the one they were signing up for.
 *
 * Two pitch pages is the actual defect; recolouring this one would only have
 * hidden it until the copy drifted again. The marketing page's own REGISTER
 * YOUR SHOP button points back at the app, so the signup loop still closes.
 *
 * The ROUTE is kept rather than deleted because three things still reference
 * it: the LEARN MORE button on shop registration, MorePanel's "become a shop"
 * path, and the post-login destination allow-list in lib/post-login-dest.ts.
 * Deleting the route would 404 all three.
 */

const MARKETING_URL = 'https://bit-brew.coffee/for-shops';

function ForShops() {
  useEffect(() => {
    // `replace` so the browser's back button returns to whatever the owner was
    // doing (usually mid-registration) rather than bouncing them forward again.
    window.location.replace(MARKETING_URL);
  }, []);

  // Shown only for the instant before the redirect lands, and as the fallback
  // if a browser blocks it. Cream + coral so it matches the app either way.
  return (
    <main className="min-h-dvh bg-background text-primary flex items-center justify-center p-8 safe-shell">
      <div className="text-center">
        <p className="font-heading text-[8px] text-body-grey uppercase mb-3">Taking you to</p>
        <a
          href={MARKETING_URL}
          className="font-grotesk font-bold text-[17px] text-coral underline"
        >
          bit-brew.coffee/for-shops
        </a>
      </div>
    </main>
  );
}

export default ForShops;
